import React from "react";
import { BoxIcon } from "lucide-react";
interface MedallionProps {
  icon: BoxIcon;
  tone?: 'tint' | 'gold';
  size?: 'default' | 'large';
  className?: string;
}
export function Medallion({
  icon: Icon,
  tone = 'tint',
  size = 'default',
  className = ''
}: MedallionProps) {
  const colors = tone === 'tint' ? 'bg-gold-tint text-gold-text' : 'bg-gold text-navy';
  const dims = size === 'large' ? 'h-16 w-16' : 'h-11 w-11';
  const iconDims = size === 'large' ? 'h-8 w-8' : 'h-5 w-5';
  return <span className={`inline-flex shrink-0 items-center justify-center rounded-full ${colors} ${dims} ${className}`} aria-hidden="true" data-id="element-167" data-mp="2dbjkbovz3pw0">
      <Icon className={iconDims} strokeWidth={2} data-id="element-168" data-mp="2i3a1adpf1bwe" />
    </span>;
}